import { useMutation } from 'react-query';

import { deleteTag as mutationFn } from 'api/endPoints/deleteTag';

export const useMutationDeleteTag = () => {
    return useMutation<string, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

interface QueryParams {
    tagId: number;
}
